
const LegalNotice = () => {
  return (
    <div className="min-h-screen pt-24 pb-16 bg-background">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto bg-card p-8 rounded-lg shadow-sm border border-border">
          <h1 className="text-3xl font-bold text-brand-blue dark:text-brand-orange mb-8">Mentions Légales</h1>
          
          <div className="space-y-6 text-muted-foreground">
            <section>
              <h2 className="text-xl font-semibold text-brand-blue dark:text-brand-orange mb-4">1. Informations légales</h2>
              <p>
                Skillengers est une société [type de société] au capital de [montant] euros,
                immatriculée au Registre du Commerce et des Sociétés de [ville] sous le numéro [numéro].
                Siège social : [adresse complète]
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-brand-blue dark:text-brand-orange mb-4">2. Directeur de la publication</h2>
              <p>
                [Nom du directeur de la publication]
                Contact : [email]
              </p>
            </section>

            <section>
              <h2 className="text-xl font-semibold text-brand-blue dark:text-brand-orange mb-4">3. Hébergeur</h2>
              <p>
                Ce site est hébergé par [nom de l'hébergeur],
                [adresse de l'hébergeur],
                [téléphone de l'hébergeur]
              </p>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalNotice;
